import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import MeasurementTable from './MeasurementTable.json';
import DataRow from './DataRow.json';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Medicaprof from './Medicaprof.json';
import CaptureViewportModal from './CaptureViewportModal.json';
import Colormaps from './Colormaps.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DataTable from './DataTable.json';
import ErrorBoundary from './ErrorBoundary.json';
import HotkeysValidators from './HotkeysValidators.json';
import Hps from './Hps.json';
import Messages from './Messages.json';
import Modes from './Modes.json';
import Onboarding from './Onboarding.json';
import PanelSUV from './PanelSUV.json';
import ROIThresholdConfiguration from './ROIThresholdConfiguration.json';
import SegmentationPanel from './SegmentationPanel.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';
import Tools from './Tools.json';
import TooltipClipboard from './TooltipClipboard.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import USAnnotationPanel from './USAnnotationPanel.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';

export default {
  de: {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    MeasurementTable,
    DataRow,
    StudyList,
    UserPreferencesModal,
    ViewportDownloadForm,
    Medicaprof,
    CaptureViewportModal,
    Colormaps,
    DataSourceConfiguration,
    DataTable,
    ErrorBoundary,
    HotkeysValidators,
    Hps,
    Messages,
    Modes,
    Onboarding,
    PanelSUV,
    ROIThresholdConfiguration,
    SegmentationPanel,
    SidePanel,
    StudyBrowser,
    StudyItem,
    ThumbnailTracked,
    ToolbarLayoutSelector,
    Tools,
    TooltipClipboard,
    TrackedCornerstoneViewport,
    USAnnotationPanel,
    WindowLevelActionMenu,
  },
};
